module.exports = __webpack_public_path__ + "static/media/education.961bbb28.svg";